import { Breadcrumb } from "@/components/ui/breadcrumb";
import { ReconciliationRunHistoryStateView } from "@/features/oversight/reconciliation-run-history";

// Deferred (page-delivery-pipeline.md G6, 2026-09-23). alloy-reconflow-service is a README,
// not a module: no pom.xml, no src/, no migrations. See
// context/page_pipeline/BACKEND_GAPS.md rows 20-23.
//
// The page renders the run history's real state surface with the
// `unavailableReason` set, so the loading/empty/error/list branches are
// implemented and pinned by tests while the honest thing on screen stays "not
// available yet" — never a fabricated "No reconciliation runs yet", which would
// claim a reconciliation service answered when none exists.
export default function ReconciliationRunHistoryPage() {
  return (
    <div>
      <Breadcrumb items={[{ label: "Reconciliation", href: "/reconciliation" }, { label: "Run History" }]} />
      <ReconciliationRunHistoryStateView
        runs={null}
        loading={false}
        error={null}
        unavailableReason="This is not available in your environment yet."
      />
    </div>
  );
}
